<div class="card bg-white dark:bg-gray-950">
  <div class="card-header title-font-selector {{headerBackground}}" [class.rounded]="rounded">
    <ng-content select="[header]"></ng-content>
  </div>

  <div class="card-body">
    @if (!loadingValue$) {
      @if (!noDataFoundValue$) {
        <ng-content select="[body]"></ng-content>
      } @else {
        <app-no-data-message [customMessage]="noDataMessage ?? null"></app-no-data-message>
      }
    } @else {
      <div class="py-3">
        <app-loader-small></app-loader-small>
      </div>
    }
  </div>
</div>


